{
  "blocks": [
    {
      "id": "proc-mock-transfer",
      "kind": "procedure",
      "tags": ["clinic-visit", "her", "pre-cycle", "ivf", "fet", "practical"],
      "title": "Mock Embryo Transfer",
      "subtitle": "Practice transfer to map the cervical path and uterine depth",
      "body": {
        "procedureName": "Mock (Trial) Embryo Transfer",
        "category": "diagnostic",
        "description": "A mock embryo transfer is a practice run of the real embryo transfer procedure. It can help the clinic document the cervical path, uterine depth, and equipment or approach to consider; whether it is useful depends on your anatomy, history, and clinic practice.",
        "howItWorks": "The procedure mimics a real embryo transfer without placing an embryo. The clinic may use a speculum, a catheter, and ultrasound, and may record the cervical angle, resistance, uterine depth, or equipment used. Some clinics combine it with another assessment. A mock transfer can feel different from person to person, including pressure or cramping; ask your clinic what preparation and pain relief are appropriate for you.",
        "duration": "5-10 minutes",
        "costRange": {
          "low": 100,
          "high": 350
        },
        "currency": "USD",
        "anesthesia": "none",
        "painAndComfort": [
          "You may feel pressure or brief cramping when the speculum or catheter is placed."
        ],
        "recoveryTime": "Most people leave after the appointment, but follow your clinic's activity and symptom instructions",
        "risks": [
          "Mild pressure or brief cramping",
          "Very rare risk of infection"
        ],
        "prepInstructions": [
          "Ask your clinic whether a full bladder is needed and how to prepare for the ultrasound",
          "Ask before taking any pain medicine or sedative, including an over-the-counter medicine",
          "Tell the clinic about allergies, pregnancy possibility, medicines, and symptoms that may affect the appointment",
          "Follow the clinic's instructions about food, drink, transport, and aftercare"
        ],
        "whatToExpect": [
          "A speculum is placed and the cervix is visualized",
          "A catheter may be passed through the cervical canal into the uterus",
          "You may feel pressure or cramping; tell the team if the procedure is painful or you need a pause",
          "The clinic may use ultrasound and record measurements or the approach used",
          "The appointment length and aftercare vary by the assessments performed",
          "Ask what symptoms should prompt a call after the appointment"
        ],
        "frBody": {
          "procedureName": "Transfert d'embryon à blanc (essai)",
          "description": "Le transfert d'embryon à blanc est une répétition du geste réel, sans dépôt d'embryon. Il peut aider le centre à documenter le trajet du col, la profondeur de l'utérus et le matériel ou l'approche à envisager ; son intérêt dépend de votre anatomie, de vos antécédents et des pratiques du centre.",
          "howItWorks": "Le geste reproduit un transfert réel sans déposer d'embryon. Le centre peut utiliser un spéculum, un cathéter et une échographie, puis noter l'angle du col, une résistance, la profondeur utérine ou le matériel utilisé. Certains centres l'associent à une autre évaluation. Le transfert à blanc peut être ressenti différemment selon les personnes, avec une pression ou des crampes ; demandez à votre centre quelle préparation et quel soulagement sont adaptés à votre situation.",
          "recoveryTime": "La plupart des personnes repartent après le rendez-vous, mais suivez les consignes de votre centre concernant les activités et les symptômes",
          "duration": "La durée varie selon les évaluations réalisées",
          "risks": [
            "Pression ou crampes ; signalez une douleur importante ou persistante",
            "Risque infectieux faible mais possible, selon le geste réalisé"
          ],
          "prepInstructions": [
            "Demandez à votre centre si une vessie pleine est nécessaire et comment vous préparer à l'échographie",
            "Demandez conseil avant de prendre un antidouleur ou un sédatif, y compris sans ordonnance",
            "Signalez vos allergies, une éventuelle grossesse, vos médicaments et tout symptôme important",
            "Suivez les consignes du centre concernant les repas, les boissons, le transport et les soins après le geste"
          ],
          "whatToExpect": [
            "Un spéculum est placé et le col est visualisé",
            "Un cathéter peut être introduit dans le canal cervical et l'utérus",
            "Vous pouvez ressentir une pression ou des crampes ; signalez une douleur ou demandez une pause",
            "Le centre peut utiliser l'échographie et noter les mesures ou l'approche employée",
            "La durée et les soins après le rendez-vous varient selon les examens réalisés",
            "Demandez quels symptômes doivent motiver un appel après le rendez-vous"
          ]
        },
        "forWhom": "her"
      },
      "sources": [
        {
          "title": "Performing the embryo transfer: a guideline",
          "authors": "Practice Committee of the ASRM",
          "journal": "Fertility and Sterility",
          "year": 2017,
          "url": "https://pubmed.ncbi.nlm.nih.gov/28366416/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
